import {
  ADD_TO_CART,
  DELETE_ITEM,
  UPDATE_CARTITEM_QUANTITY,
} from "./actionType";

export const addToCart = (cartItem) => {
  return {
    type: ADD_TO_CART,
    payload: cartItem,
  };
};

export const updateCartItemQunatity = (id, type) => {
  return {
    type: UPDATE_CARTITEM_QUANTITY,
    payload: { id, type },
  };
};

export const deleteCartItem = (id) => {
  return {
    type: DELETE_ITEM,
    payload: id,
  };
};
